import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import {
  getCompletedRequestsByLocation,
  getCompletedRequestsByResource,
} from '../../api/production-request-api/index.js';
import { useAppContext } from '../../providers';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to get completed requests within 3 days
 * @param {'resource' | 'location'} fetchBy - Whether to fetch requests by resource or location
 * @param {boolean} active - Whether the query should be active
 */
export const useCompletedRequests = (fetchBy, active) => {
  const { apiReady } = useApiReady();
  const { selectedResource, selectedLocation } = useAppContext();

  const queryKey =
    fetchBy === 'resource'
      ? [QUERY_KEYS.COMPLETED_REQUESTS_BY_RESOURCE, selectedResource]
      : [QUERY_KEYS.COMPLETED_REQUESTS_BY_LOCATION, selectedLocation];

  const queryFn =
    fetchBy === 'resource'
      ? () => getCompletedRequestsByResource(selectedResource)
      : () => getCompletedRequestsByLocation(selectedLocation);

  const enabled =
    fetchBy === 'resource'
      ? Boolean(apiReady && selectedResource && active)
      : Boolean(apiReady && selectedLocation && active);

  return useQuery({
    queryKey,
    queryFn,
    enabled,
  });
};
